import { Experience } from "../types";

export const experiences: Experience[] = [
  {
    id: "kdiesel",
    company: "KDiesel Srl",
    period: "2024–presente",
    position: "Sviluppatore Software (Industriale)",
    description:
      "Sviluppo software per macchine di misura di pompe e iniettori diesel, con integrazione hardware e gestione sistemi legacy.",
    achievements: [
      "Sviluppo API in .NET 9 per acquisizione e gestione dati di test",
      "Refactoring di applicazioni legacy migliorando manutenibilità e stabilità",
      "Gestione comunicazioni con dispositivi hardware (seriali e strumenti di misura)",
      "Introduzione di strumenti AI per velocizzare sviluppo e debugging",
      "Documentazione tecnica strutturata per supporto interno e manutenzione",
    ],
  },
  {
    id: "candiani",
    company: "Candiani SpA",
    period: "2003–2024",
    position: "Sistemista & Sviluppatore Software",
    description:
      "Responsabile sviluppo software e infrastruttura IT in azienda manifatturiera (denim), con forte focus su automazione industriale e integrazione sistemi.",
    achievements: [
      "Automazione completa dei magazzini con RFID integrato con muletti",
      "Sviluppo sistemi di pianificazione produzione con distinte base multilivello",
      "Realizzazione dashboard web per monitoraggio produzione in tempo reale",
      "Sviluppo sistema di calcolo dinamico costi/prezzi basato su distinta base",
      "Gestione integrazione ERP Sage X3 e sistemi aziendali",
      "Integrazione con fornitori esterni per gestione packing list eterogenee",
      "Sviluppo portali web per consultazione dati tecnici e analisi (grafici temporali)",
      "Sistema Gantt web drag&drop per gestione avanzata telai",
      "Gestione documentale e fatturazione elettronica (Arxivar)",
      "Gestione timbrature e integrazione con sistema paghe INAZ",
      "Virtualizzazione infrastruttura (VMware/Hyper-V) e gestione rete (VLAN, firewall)",
      "Coordinamento team IT di 4 persone",
      "Supporto IT per azienda con fatturato ~90M€",
      "Sistema automatico di classificazione dati spettrofotometrici",
    ],
  },
  {
    id: "rinascente",
    company: "Rinascente SpA",
    period: "1999–2003",
    position: "System Administrator Unix/Linux",
    description:
      "Gestione infrastruttura Unix/Linux e reti aziendali in ambiente enterprise.",
    achievements: [
      "Gestione e manutenzione sistemi Unix/Linux",
      "Risoluzione problematica Y2K su sistemi critici",
      "Configurazione e gestione reti aziendali",
    ],
  },
  {
    id: "trc",
    company: "TRC SpA",
    period: "1995–1999",
    position: "Programmatore",
    description: "Sviluppo software gestionale e supporto infrastruttura IT.",
    achievements: [
      "Sviluppo applicazioni gestionali aziendali in Visual Basic",
      "Progettazione e gestione database (Microsoft Access, SQL Server e dBase III / DB3)",
      "Supporto networking e manutenzione sistemi aziendali",
    ],
  },
  {
    id: "carlogavazzi",
    company: "Carlo Gavazzi SpA",
    period: "1993–1995",
    position: "Tecnico Elettrotecnico",
    description:
      "Attività su impianti elettrici industriali e supporto tecnico.",
    achievements: [
      "Installazione e manutenzione sistemi elettrici",
      "Supporto tecnico su impianti industriali",
    ],
  },
];
